import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import * as Yup from "yup";
import { CustomSelect, postData } from "../Commonfunction/CommonFunction";
import { toast } from "react-toastify";
import { Field, Form, Formik } from "formik";
import HistoryData from "./HistoryData";

export default function CustomersFileHistoryFilter({
  addTax,
  onClose,
  monthWiseRow,
  isSingleMonth = false,
}) {
  const [value, setValue] = useState("0");
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();

  const fetchData = async () => {
    try {
      let apiEndpoint = "";
      if (value === "1") {
        apiEndpoint = `/api/get-all-customer-files-by-current-financial-year/${id}`;
      } else if (value === "2") {
        apiEndpoint = `/api/get-all-customer-files-by-previous-financial-year/${id}`;
      } else if (value === "3") {
        apiEndpoint = `/api/customer-all-files/${id}`;
      } else {
        setIsLoading(true);
        apiEndpoint = isSingleMonth
          ? `/api/getReviewDataMonthwise/${id}`
          : `/api/getReviewDataMonthwise/${id}`;
      }
      const data = new Date();
      const currentMonth = data.getMonth() + 1;
      const currentYear = data.getFullYear();
      // console.log("Current Month:", currentMonth);
      // console.log("Current Year:", currentYear);
      const result = await postData(
        apiEndpoint,
        isSingleMonth
          ? {
              // year: currentMonth == 1 ? currentYear - 1 : currentYear,
              year: currentMonth == 1 ? currentYear - 1 : currentYear,
              filter_type: "annual",
              month: currentMonth - 1,
            }
          : {
              // year: currentMonth == 1 ? currentYear - 1 : currentYear,
              year: currentMonth == 1 ? currentYear - 1 : currentYear,
              filter_type: "annual",
            }
      );
      if (result) {
        const values = {
          year: currentMonth == 1 ? currentYear - 1 : currentYear,
          value: "annual",
        };
        let { customerdata, taxhead, ...updatedQty } = result;
        const qtyOne = removeMainObject(updatedQty, customerdata);
        const singleMonthData = transformData(qtyOne);
        const monthData = getFullMonthData(singleMonthData, currentMonth - 1);
        // console.log('qtyOne11111', singleMonthData, monthData)
        isSingleMonth
          ? await setTableData(singleMonthData)
          : await getTableData(qtyOne, values);
        // setTableData(result.data);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to fetch data");
    }
  };
  function getFullMonthData(monthData, month) {
    if (monthData[month]) {
      return { [month]: monthData[month] };
    } else {
      console.warn(`${month} data does not exist.`);
      return {};
    }
  }

  function removeMainObject(data, customerdata) {
    let newData = {};

    for (const month in data) {
      if (data[month]?.hasOwnProperty("Calculation_Total")) {
        const calculationTotal = data[month]["Calculation_Total"];
        let updatedMonthData = { ...data[month] };

        if (
          customerdata?.business_type === "Hotel - Motel" &&
          updatedMonthData?.HOTEL_OCCUPANY?.Room_Tax
        ) {
          // Move "Room_Tax" outside of "HOTEL_OCCUPANY"
          updatedMonthData["Room_Occupacy_Tax"] =
            updatedMonthData["HOTEL_OCCUPANY"]["Room_Tax"];
          delete updatedMonthData["HOTEL_OCCUPANY"]["Room_Tax"];
        } else if (customerdata?.business_type === "Tennessee") {
          updatedMonthData = { "": "", ...updatedMonthData };
        } else {
          // Only add "Gross_Non_fuel_sale" if it exists in calculationTotal
          if (calculationTotal?.["Gross_Non_fuel_sale"] !== undefined) {
            updatedMonthData = {
              Gross_Non_fule: {
                Gross_Non_fuel_sale: calculationTotal["Gross_Non_fuel_sale"],
              },
              ...updatedMonthData,
            };
          }
        }

        data[month] = updatedMonthData;
      }
      if (data[month]?.hasOwnProperty("Tax_Return_upload")) {
        delete data[month]?.Tax_Return_upload;
      }
      // console.log('daa777---', data[ month ]?.hasOwnProperty("Tax_Return_upload"))
      // Remove the "Main" key if it exists
      if (data[month].hasOwnProperty("Main")) {
        delete data[month]["Main"];
      }

      // Iterate through the sub-objects to move "Total" to the end
      for (const category in data[month]) {
        const currentObj = data[month][category];
        if (
          ["Gas", "Diesel", "Other"].includes(category) &&
          currentObj.hasOwnProperty("Total")
        ) {
          delete currentObj["Total"];
        }
        if (
          ["Calculation_Total"].includes(category) &&
          currentObj.hasOwnProperty("Gross_Non_fuel_sale")
        ) {
          delete currentObj["Gross_Non_fuel_sale"];
          delete currentObj["Total_Gas_Diesel_gallon"];
          delete currentObj["Total_Gas_Diesel_sale"];
          delete currentObj["Total_Gas_Diesel_sale_MIn"];
        }

        if (currentObj.hasOwnProperty("Total")) {
          // Extract the Total value
          const totalValue = currentObj["Total"];
          // Delete the Total key
          delete currentObj["Total"];
          // Add the Total key back at the end
          currentObj["Total"] = totalValue;
        }
        if (currentObj.hasOwnProperty("Total_Amount_Due")) {
          const TotalAmountDue = currentObj["Total_Amount_Due"];
          // delete currentObj["Total_Amount_Due"];
          currentObj["Final_Total_Amount_Due"] = TotalAmountDue;
        }
      }
    }
    return data;
  }

  const transformData = (data) => {
    const result = {};

    for (const [month, details] of Object.entries(data)) {
      result[month] = {};

      for (const [key, value] of Object.entries(details)) {
        if (typeof value === "object" && !Array.isArray(value)) {
          // Transform nested objects into the desired array of objects format
          result[month][key] = Object.entries(value).map(
            ([subKey, subValue]) => {
              return { [subKey]: subValue };
            }
          );
        } else {
          // Handle top-level values if necessary
          result[month][key] = [{ [key]: value }];
        }
      }
    }

    return result;
  };
  const getTableData = async (qtyOne, values) => {
    const filter = values.value; // q1, q2, q3, q4, anual
    const availableMonths = Object.keys(qtyOne);
    // This is Common Qty Month Function
    const qtyMonth = (months) => {
      months.forEach((month) => {
        if (!availableMonths.includes(month)) {
          // If no reference month is available, throw an error
          if (availableMonths.length === 0) {
            throw new Error(
              "No reference data available to construct missing months."
            );
          }

          // Use the first available month as a reference
          const referenceMonth = availableMonths[0];
          const newMonthData = {};

          // Dynamically create the structure for the missing month with zero values
          Object.keys(qtyOne[referenceMonth]).forEach((category) => {
            newMonthData[category] = {};
            Object.keys(qtyOne[referenceMonth][category]).forEach((key) => {
              newMonthData[category][key] = 0; // Set all values to zero
            });
          });

          // Find the position of the missing month in the months array
          let monthIndex = months.indexOf(month);

          // Insert the missing month at the correct position in qtyOne
          if (monthIndex === 0) {
            // If the missing month is at the start
            qtyOne = { [month]: newMonthData, ...qtyOne };
          } else if (monthIndex === months.length - 1) {
            // If the missing month is at the end
            qtyOne[month] = newMonthData;
          } else {
            // Insert the missing month in the middle
            let beforeMonth = months[monthIndex - 1];
            let afterMonth = months[monthIndex + 1];

            let updatedQtyOne = {};
            Object.keys(qtyOne).forEach((key) => {
              updatedQtyOne[key] = qtyOne[key];
              if (key === beforeMonth) {
                updatedQtyOne[month] = newMonthData; // Insert the missing month after the `beforeMonth`
              }
            });

            // Ensure the remaining months after the insertion are added
            if (!(month in updatedQtyOne)) {
              updatedQtyOne[month] = newMonthData;
            }

            qtyOne = updatedQtyOne;
          }
          // console.log(`Inserted missing month: ${month}`, qtyOne);
        }
      });
    };
    const calculateQuarter = (months) => {
      const quarter = {};

      months.forEach((month) => {
        const monthData = qtyOne[month];
        // Iterate over each category (like "High", "Low", "Gas") to sum the values dynamically
        Object.keys(monthData).forEach((category) => {
          if (!quarter[category]) {
            quarter[category] = {};
          }

          // Sum the corresponding totals dynamically
          Object.keys(monthData[category]).forEach((key) => {
            if (!quarter[category][key]) {
              quarter[category][key] = 0;
            }
            quarter[category][key] += monthData[category][key];
          });
        });
      });

      return quarter;
    };

    if (filter == "q1") {
      // Check if any month is missing
      const months = ["January", "February", "March"];
      qtyMonth(months);
      const qtrOneData = calculateQuarter(["January", "February", "March"]);
      qtyOne["Q1 Total"] = qtrOneData;
      // console.log('qtyOne', qtyOne);
      const transformedData = transformData(qtyOne);
      await setTableData(transformedData);
    } else if (filter == "q2") {
      // Check if any month is missing
      const months = ["April", "May", "June"];
      qtyMonth(months);
      const qtrOneData = calculateQuarter(["April", "May", "June"]);
      qtyOne["Q2 Total"] = qtrOneData;
      // console.log('qtyOne', qtyOne);
      const transformedData = transformData(qtyOne);
      await setTableData(transformedData);
    } else if (filter == "q3") {
      // Check if any month is missing
      const months = ["July", "August", "September"];
      qtyMonth(months);
      const qtrOneData = calculateQuarter(["July", "August", "September"]);
      qtyOne["Q3 Total"] = qtrOneData;
      // console.log('qtyOne', qtyOne);
      const transformedData = transformData(qtyOne);
      await setTableData(transformedData);
    } else if (filter == "q4") {
      // Check if any month is missing
      const months = ["October", "November", "December"];
      qtyMonth(months);
      const qtrOneData = calculateQuarter(["October", "November", "December"]);
      qtyOne["Q4 Total"] = qtrOneData;
      // console.log('qtyOne', qtyOne);
      const transformedData = transformData(qtyOne);
      await setTableData(transformedData);
    } else {
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      qtyMonth(months);
      // // Calculate the quarterly totals for Q1, Q2, Q3, and Q4
      const qtrOneData = calculateQuarter(["January", "February", "March"]);
      const qtrTwoData = calculateQuarter(["April", "May", "June"]);
      const qtrThreeData = calculateQuarter(["July", "August", "September"]);
      const qtrFourData = calculateQuarter(["October", "November", "December"]);

      // Add the quarterly data to the original data object
      qtyOne["Q1 Total"] = qtrOneData;
      qtyOne["Q2 Total"] = qtrTwoData;
      qtyOne["Q3 Total"] = qtrThreeData;
      qtyOne["Q4 Total"] = qtrFourData;

      // Calculate the overall total by summing Q1, Q2, Q3, and Q4 totals
      const total = {};

      const addQuarterData = (quarterData) => {
        Object.keys(quarterData).forEach((category) => {
          if (!total[category]) {
            total[category] = {};
          }

          Object.keys(quarterData[category]).forEach((key) => {
            if (!total[category][key]) {
              total[category][key] = 0;
            }
            total[category][key] += quarterData[category][key];
          });
        });
      };

      addQuarterData(qtrOneData);
      addQuarterData(qtrTwoData);
      addQuarterData(qtrThreeData);
      addQuarterData(qtrFourData);
      qtyOne["Total"] = total;
      // console.log('Final qtyOne:', qtyOne);
      const desiredOrder = [
        "January",
        "February",
        "March",
        "Q1 Total",
        "April",
        "May",
        "June",
        "Q2 Total",
        "July",
        "August",
        "September",
        "Q3 Total",
        "October",
        "November",
        "December",
        "Q4 Total",
        "Total",
      ];
      const reorderedData = Object.fromEntries(
        desiredOrder.map((key) => [key, qtyOne[key]])
      );
      const transformedData = transformData(reorderedData);
      await setTableData(transformedData);
      // console.log('reorderedData==', transformedData);
    }
  };
  useEffect(() => {
    fetchData();
  }, [value]); // Fetch data whenever 'value' changes

  useEffect(() => {
    if (addTax) {
      fetchData();
    }
  }, []);
  const validationSchemaFilterModal = Yup.object().shape({
    year: Yup.string().required("Year is required"),
    filter_type: Yup.string().required("Filter type is required"),
  });

  const monthOptions = [
    /* month options here */
  ];
  const filterOptions = [
    { value: "q1", label: "Quarter 1" },
    { value: "q2", label: "Quarter 2" },
    { value: "q3", label: "Quarter 3" },
    { value: "q4", label: "Quarter 4" },
    { value: "annual", label: "Annually" },
  ];
  const yearOptions = Array.from({ length: 20 }, (_, i) => {
    const year = new Date().getFullYear() - i;
    return { value: year.toString(), label: year };
  });

  const handleSubmit = async (FinalValue) => {
    // console.log('FinalValue', FinalValue)
    try {
      // const request_url = `/api/get-customer-files-history/${id}`;
      // const request_url = await postData(`/api/tax-calculation-report-export-compile/${id}`, FinalValue);
      const postDataResult = await postData(
        `/api/tax-calculation-report-export-compile/${id}`,
        FinalValue
      );

      if (postDataResult) {
        // setTableData(postDataResult.data); // Update table data with the result
        const values = {
          year: FinalValue.year,
          value: FinalValue.filter_type,
        };
        let { customerdata, taxhead, ...updatedQty } = postDataResult;
        const qtyOne = removeMainObject(updatedQty, customerdata);
        // console.log('qtyOne11111', qtyOne)
        await getTableData(qtyOne, values);
        // toast.success(postDataResult.message);
      }
    } catch (error) {
      // const errorMessage = error.response?.data?.message || "An error occurred";
      // toast.error(errorMessage);
    }
  };
  return (
    <React.Fragment>
      <div>
        {!addTax && (
          <div className="usa-card padding-3 bg-white shadow-lg border-radius-lg">
            <Formik
              initialValues={{
                year: "",
                filter_type: "",
              }}
              validationSchema={validationSchemaFilterModal}
              onSubmit={(values) => handleSubmit(values)}
            >
              {({ errors, touched }) => (
                <Form className="width-full">
                  <div className="grid-row grid-gap">
                    <div className="grid-col-12">
                      <div className="grid-row grid-gap flex-align-end">
                        <div className="grid-col-3">
                          <label
                            className="usa-label font-sans-md text-bold"
                            htmlFor="year"
                          >
                            Select Year{" "}
                            <span className="text-secondary">*</span>
                          </label>
                          <Field
                            name="year"
                            component={CustomSelect}
                            options={yearOptions}
                          />
                          {errors.year && touched.year && (
                            <span className="usa-error-message">
                              {errors.year}
                            </span>
                          )}
                        </div>

                        <div className="grid-col-3">
                          <label
                            className="usa-label font-sans-md text-bold"
                            htmlFor="filter_type"
                          >
                            Filter Type{" "}
                            <span className="text-secondary">*</span>
                          </label>
                          <Field
                            name="filter_type"
                            component={CustomSelect}
                            options={filterOptions}
                          />
                          {errors.filter_type && touched.filter_type && (
                            <span className="usa-error-message">
                              {errors.filter_type}
                            </span>
                          )}
                        </div>

                        <div
                          className="grid-col-3 display-flex flex-align-center margin-top-2"
                          style={{ gap: "12px"}}
                        >
                          <button
                            type="submit"
                            className="usa-button usa-button- width-full"
                          >
                           Filter Data
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        )}

        <div>
          {isLoading ? (
            <p>Loading ...</p>
          ) : (
            <HistoryData
              historyMainData2={tableData}
              historyMainData={tableData}
              addTax={addTax}
              onClose={onClose}
            />
          )}
        </div>
      </div>
    </React.Fragment>
  );
}
